const capitalizeString = (label = '') => {
  const firstCharacter = label.charAt(0).toUpperCase();

  const rest = label.slice(1).toLowerCase();

  return `${firstCharacter}${rest}`;
};

const sanitizerStatusLabelText = (
  label: string,
  isItemsCases: boolean = false,
) => {
  if (label === 'OPEN' && isItemsCases) {
    label = 'NEW';
  }

  if (label === 'CLOSED' && isItemsCases) {
    label = 'END';
  }

  return capitalizeString(label).replace('_', ' ');
};

export { capitalizeString, sanitizerStatusLabelText };
